import React, { useState, useRef } from "react";
import playbutton from "../../assets/img/play-button.png";
import { openFullscreen, closeFullscreen } from "../../services/helper";
import startexp from "../../assets/img/start-exp.png";
import thumbnail from "../../assets/img/programming-hub-thumbnail.webp";

/**UI component for Introductory Programming Hub Video */
export default function ProgrammingHubVideo() {
  const [showControls, setControls] = useState(false);
  const videoRef = useRef(null);
  /**Function for playing video when clicked on play button */
  const playVideo = () => {
    openFullscreen(videoRef.current);
    videoRef.current.play();
    setControls(true);
  };
  /**Function to be called when video is ended for resetting video to its initial state */
  const onVideoEnd = () => {
    videoRef.current.currentTime = 0;
    setControls(false);
    closeFullscreen(videoRef.current);
  };
  return (
    <section className="programming-hub-video">
      <div className="container">
        <div className="row justify-content-center m-t-80 m-b-80">
          <div className="video-block">
            <picture>
              <source
                type="image/webp"   
                srcSet={`${require("../../assets/webp/start-exp.webp")}`}
              />

              <img
                className="img-fluid start-exp"
                src={startexp}
                alt="Start your learning experience today"
              />
            </picture>

            {!showControls && (
              <img
                className="img-fluid play-button bottom-left"
                src={playbutton}
                alt="Play Button"
                onClick={playVideo}
              />
            )}

            <video
              width="800"
              height="auto"
              controls={showControls}
              onClick={() => false}
              ref={videoRef}
              onEnded={onVideoEnd}
              preload="none"
              poster={thumbnail}
            >
              <source
                src="https://storage.googleapis.com/programminghub/web/video_links/prgram-hub-video_1.webm
"
                type="video/webm"
              />
              <source
                src="https://storage.googleapis.com/programminghub/web/video_links/prgram-hub-video.mp4
"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
}
